/**
 * The request bound of the client log endpoint (app/api/log/route.ts), shared
 * with the browser code that beacons to it (lib/textTrace.ts) so a sender can
 * split a record that would not fit instead of losing it to a 413 that
 * navigator.sendBeacon never reports.
 */
export const LOG_ENDPOINT_MAX_BODY_BYTES = 32 * 1024;

/**
 * /api/log is rate-limited by `rateLimiters.public` (lib/security/rate-limiter.ts): 100 requests per minute per
 * client, ONE bucket shared with every public route and with lib/logger's own shipping. The TEXT-TRACE parts of
 * a split record take at most half of it (50/min), so a long trace does not starve the other client logs and
 * is not itself refused with 429 part-way through.
 */
export const TRACE_PART_MIN_INTERVAL_MS = 1_200;

/** A part refused with 429 waits for the response's Retry-After (else this long) and is retried. */
export const TRACE_PART_RETRY_FALLBACK_MS = 60_000;

/** A part is tried at most this many times before it is reported as not stored. */
export const TRACE_PART_MAX_ATTEMPTS = 3;

/** localStorage namespace for the per-part durable queue; the bare key is read to migrate older pagehide batches. */
export const TRACE_PENDING_PARTS_KEY = 'TEXT_TRACE_PENDING_PARTS';
